import axios from "axios";
import appConfig from "@/config";
import { getCookie } from '@/utils/auth/authService';
const BASE_URL = appConfig.api.base;

export function fetchAll(perPage = 10, page = 1, para = {}) {
    const url = `${BASE_URL}/batch`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    let params = {
        per_page: perPage,
        page: page,
        ...para
    }
    
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        params
    });
}

export function fetchOrderById(perPage = 10, page = 1, id) {
    const url = `${BASE_URL}/batch/${id}`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        params: {
            per_page: perPage,
            page: page
        }
    });
}

export function runQuery(batchId, action, disburseOrderIds) {
    const url = `${BASE_URL}/disburse/queue/run`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            batchId: batchId,
            action: action,
            disburseOrderId: disburseOrderId
        }
    });
}

export function cancelQuery(status, disburseOrderIds) {
    const url = `${BASE_URL}/disburse/order/update`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");
    return axios({
        method: "post",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        data: {
            status,
            disburseOrderIds
        }
    });
}

export function downloadBatch(
    per_page=10,
    page=1,
    start,
    end,
    ref,
    download=1,
    status
) {
    const url = `${BASE_URL}/batch`;
    let token = getCookie("token");
    let merchantId = window.localStorage.getItem("merchantId");

    return axios({
        method: "get",
        url: url,
        headers: {
            "Content-Type": "application/json",
            Authorization: token,
            "merchant-id": merchantId
        },
        params: {
            per_page,
            page,
            start,
            end,
            ref,
            download,
            status
        }
    });
}



// WEBPACK FOOTER //
// ./src/utils/wallet-transactions/BatchServices.js